import { Box } from "@bca/ui-library";
import styled from "styled-components";
import { position, PositionProps } from "styled-system";

const PositionedBox = styled(Box)<PositionProps>`
  ${position};
`;

export default PositionedBox;
